import { render, staticRenderFns } from "./MainProjectBatteryListTab.vue?vue&type=template&id=4368e3a1&scoped=true&"
import script from "./MainProjectBatteryListTab.vue?vue&type=script&lang=ts&"
export * from "./MainProjectBatteryListTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4368e3a1",
  null
  
)

export default component.exports